module.exports = {
  footerText: 'Kitchen City © 2020',
}
